import * as Fa from "react-icons/fa";
import { Dropdown } from "primereact/dropdown";
import { useEffect, useState } from "react";
import LineLevelCombine from "./LineLevelCombine";
import { Link, useSearchParams } from "react-router-dom";
import LineLevelInvd from "./LineLevelInvd";

function LineLevelSchemedisc() {
  const [selectedSchemtyp, setSelectedSchemtyp] = useState<any>({
    name: "Individual Discount",
    code: "Flasdisc",
  });
  const schetypes = [
    { name: "Combined Discount", code: "Combdisc" },
    { name: "Individual Discount", code: "Flasdisc" },
  ];

  const [searchParams] = useSearchParams();
const schmCode = searchParams.get("schmID");
  useEffect(() => {
    const discTypeid = searchParams.get("discType");

    if (discTypeid == "CMB") {
      setSelectedSchemtyp({ name: "Combined Discount", code: "Combdisc" });
    } else if (discTypeid == "IND") {
      setSelectedSchemtyp({ name: "Individual Discount", code: "Flasdisc" });
    }
  }, [searchParams]);
  return (
    <>
      <div className="row">
        <div className="col-lg-4 col-md-12 col-sm-12">
          <h3 className="py-2">Line Level Discount Definition</h3>
        </div>
        <div className="col-lg-8 col-md-12 col-sm-12">
          <div className="text-end">
            <Link to="/Master/Scheme/SchemeDiscDefAllRec">
              <button type="button" className="btn anime-secondary-btn">
                <Fa.FaLongArrowAltLeft className="backIcon" /> Back to All
                Records
              </button>
            </Link>
          </div>
        </div>
      </div>

      <section className="sales-box">
        <div className="col-12">
          <div className="row d-flex justify-content-center align-items-center">
            <div className="col-lg-4 col-md-6 col-sm-12">
              <div className="d-block">
                <label className="form-label">Select Discount Base</label>
                <Dropdown
                  value={selectedSchemtyp}
                  onChange={(e) => setSelectedSchemtyp(e.value)}
                  options={schetypes}
                  optionLabel="name"
                  placeholder="Select discount type"
                  className=""
                  disabled={schmCode!=="null"}
                />
              </div>
            </div>
            <div className="col-lg-8 col-md-6 col-sm-12">
              <div className="text-end">
                <img
                  src={require("../../../../Assets/Images/discount.png")}
                  className=""
                  style={{ width: "130px" }}
                  alt="Innorise"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {selectedSchemtyp?.code == "Combdisc" ? (
        <section className="border border rounded p-3 mb-4">
          <LineLevelCombine />{" "}
        </section>
      ) : selectedSchemtyp?.code == "Flasdisc" ? (
        <section className="border border rounded p-3 mb-4">
          {" "}
          <LineLevelInvd />{" "}
        </section>
      ) : null}
    </>
  );
}

export default LineLevelSchemedisc;
